import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useRouteMatch } from "react-router-dom";

const EtaRowActions = ({ eta, onDelete }) => {
  const { path } = useRouteMatch();

  return (
    <div className="field is-grouped">
      <div className="field mr-3 mb-0">
        <div className="control">
          <Link
            to={`${path}/${eta.id}`}
            title="Editar"
            className="button is-small is-primary"
          >
            <FontAwesomeIcon icon={["fas", "edit"]} />
          </Link>
        </div>
      </div>
      <div className="field">
        <div className="control">
          <button
            title="Borrar"
            className="button is-small is-primary"
            onClick={onDelete}
          >
            <FontAwesomeIcon icon={["fas", "trash"]} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default EtaRowActions;
